import { NgModule } from '@angular/core';
import { Drivers } from '@ionic/storage';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders } from '@angular/core';
import { IonicStorageModule } from '@ionic/storage-angular';

import { StorageService } from './storage.service';

@NgModule({
  imports: [
    CommonModule,
    IonicStorageModule.forRoot({
      name: '__RSMdb',
      driverOrder: [Drivers.LocalStorage, Drivers.IndexedDB],
    }),
  ],
})
export class StorageModule {
  static forRoot(): ModuleWithProviders<StorageModule> {
    return {
      ngModule: StorageModule,
      providers: [StorageService],
    };
  }
}
